import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoginPage from './pages/LoginPage';
import Home from './pages/Home';
import MainLayout from './layouts/MainLayout';
import authUtils from './utils/authUtils';
import Profile from './pages/Profile';
import Users from './pages/UserManagement';
import BaoCaoNangSuat from './pages/BaoCaoNangSuat';
import HuongDanSuDung from './pages/HuongDanSuDung';

import GiaBanManagement from './pages/GiaBanManagement';
import DMHHManagement from './pages/DMHHManagement';
import DSKHManagement from './pages/DSKHManagement';
import HopDongNguyenTacManagement from './pages/HopDongNguyenTacManagement';
import XuatNhapKhoManager from './pages/XuatNhapKhoManager';
import XuatNhapKhoDominoManager from './pages/XuatNhapKhoDominoManager';
import ChiTietXuatNhapKhoManagement from './pages/ChiTietXuatNhapKhoManagement';
import ApprovalManagement from './pages/ApprovalManagement';


import CongDoanDonGiaManagement from './pages/CongDoanDonGiaManagement';
import PhanBoNhanSuManagement from './pages/PhanBoNhanSuManagement';
import NhapBaoBiManagement from './pages/NhapBaoBiManagement';
import PhanBoBaoBiManagement from './pages/PhanBoBaoBiManagement';

import TonKhoManager from './pages/TonKhoManager';
import TheKhoManagement from './pages/TheKhoManagement';
import BaoCaoDoanhSo from './pages/BaoCaoDoanhSo';

import QuanLyLoManagement from './pages/QuanLyLoManagement';
import ThuChiTheoLoManagement from './pages/ThuChiTheoLoManagement';
import PhuPhamManagement from './pages/PhuPhamManagement';


import NhanSuManagement from './pages/NhanSuManagement';

// XUAT PHU PHAM
import XuatPhuPhamManagement from './pages/XuatPhuPhamManagement';
import XuatPhuPhamChiTiet from './pages/XuatPhuPhamChiTiet';
import ThanhToanManagement from './pages/ThanhToanManagement';
import CongNoManagement from './pages/CongNoManagement';

// CÔNG LƯƠNG
import CauHinhCongLuong from './pages/CauHinhCongLuong';
import MauBangLuong from './pages/MauBangLuong';
import ThoaThuanCongLuong from './pages/ThoaThuanCongLuong';
import UngLuong from './pages/UngLuong';
import BangCongLuong from './pages/BangCongLuong';
import BangCongLuongChiTiet from './pages/BangCongLuongChiTiet';
import BaoCaoCongLuong from './pages/BaoCaoCongLuong';
import LichNgayLe from './pages/LichNgayLe';
import PhepNam from './pages/PhepNam';
import SoTienGiuLai from './pages/SoTienGiuLai';
import BangCongLuongIn from './pages/BangCongLuongIn';



// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const location = useLocation();

  if (!authUtils.isAuthenticated()) {
    // Lưu lại đường dẫn hiện tại trước khi chuyển hướng
    localStorage.setItem('returnUrl', location.pathname + location.search);
    return <Navigate to="/" replace />;
  }
  return children;
};

function App() {
  return (
    // Không cần basename vì đã có domain
    <BrowserRouter>
      <ToastContainer position="top-right" />
      <Routes>
        <Route path="/" element={<LoginPage />} />
        {/* Trang in bảng lương nằm ngoài khung menu để bản in không dính thanh menu */}
        <Route path="/in/bangcongluong/:maKy" element={<ProtectedRoute><BangCongLuongIn /></ProtectedRoute>} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <MainLayout>
                <Routes>
                  <Route path="/home" element={<Home />} />
                  <Route path="/profile" element={<Profile />} />
                  <Route path="/users" element={<Users />} />

                  <Route path="/giaban" element={<GiaBanManagement />} />
                  <Route path="/dmhh" element={<DMHHManagement />} />
                  <Route path="/dskh" element={<DSKHManagement />} />
                  <Route path="/hopdongnguyentac" element={<HopDongNguyenTacManagement />} />
                  <Route path="/xuatnhapkho" element={<XuatNhapKhoManager />} />
                  <Route path="/xuatnhapkhodomino" element={<XuatNhapKhoDominoManager />} />
                  <Route path="/chitietxuatnhapkho" element={<ChiTietXuatNhapKhoManagement />} />
                  <Route path="/duyet_sua_phieu" element={<ApprovalManagement />} />
                  <Route path="/tonkho" element={<TonKhoManager />} />
                  <Route path="/makien" element={<TheKhoManagement />} />

                  <Route path="/nhapbaobi" element={<NhapBaoBiManagement />} />
                  <Route path="/chitiet_phanbo" element={<PhanBoBaoBiManagement />} />
                  <Route path="/congdoan_dongia" element={<CongDoanDonGiaManagement />} />
                  <Route path="/phanbonhansu" element={<PhanBoNhanSuManagement />} />
                  <Route path="/baocao_nangsuat" element={<BaoCaoNangSuat />} />
                  <Route path="/baocaobanhang" element={<BaoCaoDoanhSo />} />
                  <Route path="/huongdansudung" element={<HuongDanSuDung />} />

                  <Route path="/nhansu" element={<NhanSuManagement />} />
                  <Route path="/quanlylo" element={<QuanLyLoManagement />} />
                  <Route path="/thuchi" element={<ThuChiTheoLoManagement />} />
                  <Route path="/phupham" element={<PhuPhamManagement />} />
                  {/* <Route path="/xuatphupham" element={<MainLayout><div className="p-4">Quản lý xuất phụ phẩm (Đang phát triển)</div></MainLayout>} /> */}
                  <Route path="/xuatphupham" element={<XuatPhuPhamManagement />} />
                  <Route path="/chitietxuatphupham" element={<XuatPhuPhamChiTiet />} />
                  <Route path="/thanhtoan" element={<ThanhToanManagement />} />
                  <Route path="/congno" element={<CongNoManagement />} />

                  <Route path="/cauhinh_congluong" element={<CauHinhCongLuong />} />
                  <Route path="/maubangluong" element={<MauBangLuong />} />
                  <Route path="/thoathuan_congluong" element={<ThoaThuanCongLuong />} />
                  <Route path="/ungluong" element={<UngLuong />} />
                  <Route path="/bangcongluong" element={<BangCongLuong />} />
                  <Route path="/bangcongluong/tao-moi" element={<BangCongLuongChiTiet createMode />} />
                  <Route path="/bangcongluong/:maKy" element={<BangCongLuongChiTiet />} />
                  <Route path="/baocao_congluong" element={<BaoCaoCongLuong />} />
                  <Route path="/lichngayle" element={<LichNgayLe />} />
                  <Route path="/phepnam" element={<PhepNam />} />
                  <Route path="/sotiengiulai" element={<SoTienGiuLai />} />


                  <Route path="/" element={<Navigate to="/home" replace />} />
                </Routes>
              </MainLayout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;